import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.ChildContainer,
  title: 'Child Container',
  category: ComponentCategory.Layout,
  droppable: true,
  showInLibrary: false,
};
